// mutation-types.js

// navigation
export const TOGGLE_SIDEBAR = "navigation/TOGGLE_SIDEBAR";
export const SET_SIDEBAR_STATE = "navigation/SET_SIDEBAR_STATE";
export  const SET_SIDEBAR_COMPONENT = "navigation/SET_SIDEBAR_COMPONENT";

export const LOGIN_REQUEST = "auth/LOGIN_REQUEST";
export const LOGIN_SUCCESS = "auth/LOGIN_SUCCESS";
export const LOGIN_FAILURE = "auth/LOGIN_FAILURE";
export const LOGIN_EXPIRE  = "auth/LOGIN_EXPIRE";
export const LOGIN_LOGOUT  = "auth/LOGIN_LOGOUT";



// WEBPACK FOOTER //
// ./src/store/mutation-types.js